<div fxLayout="column">
    @if (showHeader) {
    <div style="margin-bottom: 1rem" fxLayout="row" fxFlex="100" fxLayoutAlign="space-between center">
        @if (metadata.Title !== undefined && metadata.Title.length > 0) {
        <div class="forge-typography--heading2">
            {{metadata.Title}}
        </div>
        }
        @if (!allowPaging) {
        <div style="height: 0"></div>
        }
        @if (allowPaging && pagingTop) {
        <div fxLayout="row" fxLayoutAlign="start center" fxFlex>
            <forge-paginator (forge-paginator-change)="paginate($event.detail)" [total]="models.length"
                [pageSize]="rowsPerPage" [pageIndex]="pageIndex" style="position: sticky; right: 24px;" first-last
                alternative>
            </forge-paginator>
        </div>
        }
        @if (!viewOnly && metadata.CanAdd) {
        <div fxLayoutAlign="start start">
            <forge-button class="panel-grid--add-button" variant="raised" [disabled]="viewOnly || !canAddProperty()"
                telemetry="Submission-AddItem" (click)="addRow()">
                <div fxLayout="row" fxLayoutAlign="space-between center">
                    <forge-icon name="add" style="--forge-icon-color: var(--forge-theme-on-primary);"></forge-icon>
                    <span>Add</span>
                </div>
            </forge-button>
        </div>
        }
    </div>
    }
    @if (showHeader) {
    <forge-divider class="forge-card--divider-mb"></forge-divider>
    }
    <div [ngStyle]="{'overflow-x': noWrap ? 'auto' : null}">
        @for (model of shownModels; track model) {
        <div fxLayout="row" [ngStyle]="{'width': noWrap ? 'max-content' : null}">
            <div class="layout-column layout-fill">
                <div fxLayout="row" [attr.layoutAlign]="layoutAlign">
                    <metadata-panel [viewOnly]="viewOnly || !canEdit(model)" [model]="model"
                        [metadata]="metadata.ClassMetadata" [focusFirst]="focusFirst && (!metadata.CanAdd)"
                        [dense]="dense" [noWrap]="noWrap" [compact]="compact" [datacontroller]="datacontroller"
                        (modifierCallback)="callback($event)" [index]="$index" [onPanelGrid]="true" fxFlex>
                    </metadata-panel>
                    <metadata-panel-grid-actions [model]="model" [metadata]="metadata" [viewOnly]="viewOnly"
                        [index]="getIndex(model)" [canAdd]="canAdd" [hasEditFunction]="hasEditFunction"
                        (deleteAction)="delete($event)" (copyAction)="copy($event)"
                        (customFunction)="fireCustomFunction($event)" (afterAction)="refreshGrid()">
                    </metadata-panel-grid-actions>
                </div>
                <forge-divider [hidden]="$last" class="forge-card--divider-mb"></forge-divider>
            </div>
        </div>
        }
    </div>
    @if (summaryMetadataExists()) {
    <div fxLayout="row">
        <metadata-summary-panel [model]="summaryModel" [metadata]="summaryMetadata" [actionCount]="numberOfActions"
            fxFlex>
        </metadata-summary-panel>
    </div>
    }
    @if (allowPaging && !pagingTop) {
    <div fxLayout="row" fxLayoutAlign="end center" fxFlex>
        <forge-paginator (forge-paginator-change)="paginate($event.detail)" [total]="models.length"
            [pageSize]="rowsPerPage" [pageIndex]="pageIndex" style="position: sticky; right: 24px;" first-last
            alternative>
        </forge-paginator>
    </div>
    }
</div>